import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CreditBalanceInterface } from 'features/AdsManagement/@types/apiTypes'

export const SLICE_NAME = 'adsAddApprovalRedux'

interface AdsAddApprovalReduxInterface {
  isLoading: boolean
  principalList: CreditBalanceInterface[]
}

const initialState: AdsAddApprovalReduxInterface = {
  isLoading: false,
  principalList: [],
}

const adsAddApprovalSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setPrincipalList: (state, action: PayloadAction<CreditBalanceInterface[]>) => {
      state.principalList = action.payload
    },
  },
})

export const { setIsLoading, setPrincipalList } = adsAddApprovalSlice.actions

export default adsAddApprovalSlice.reducer
